import * as types from '../actions/actionTypes';

export const authInfo = (state = {authenticated : false, IsAdmin : false, Loading : true}, action) => {
  switch(action.type){
    case types.AUTH_USER : 
    case types.AUTH_USER_REJECTED:
      return {authenticated : false, IsAdmin : false , Loading : true};
    case types.AUTH_USER_FULFILLED:
      return {...action.payload, authenticated : true, Loading : false}
    default :
      return state;
  }
}


export const summaryInfo = (state = {Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_SUMMARY_INFO : 
    case types.FETCH_SUMMARY_INFO_REJECTED:
      return {...state, Loading : true};
    case types.FETCH_SUMMARY_INFO_FULFILLED:
      return {...action.payload, Loading : false};
    default :
      return state;
  }
}

export const locale = (state = '', action) => {
  switch(action.type){
    case types.SET_LOCALE : 
      state = action.payload
    default :
      return state;
  }
}
 


// WEBPACK FOOTER //
// ./reducers/authInfoReducer.js